import React from 'react';
import { ExcelTableCellProps } from '../../TableCell';
import { observer } from 'mobx-react';
import { getDomIdByFieldKey } from '../../../../util/typeUtil';
import { WeaSelect } from 'ecCom';
import _ from 'lodash';

@observer
export default class SelectElement extends React.Component<ExcelTableCellProps, any>{
    render() {
        const { cell, form, card, className, excel } = this.props;
        const path = cell.getPath();
        const bindObj = form.$(path);
        const {quickEditStore,getDetailFormValues,DetailDatas} = card;
        let fieldName = getDomIdByFieldKey(bindObj.path);
        const { value, viewAttr: _viewAttr, isEdit, isMandatory, options: filtedOptions } = bindObj.bind();
        let { fieldtype, options, fieldshowtypes, isdetail } = card.getFieldProps(path);
        let viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if(excel.detailProps&&excel.detailProps.hasOwnProperty("isEdit")&&card.params.type == '2'){
            //如果明细表字段，设置了不可编辑已有明细,则已有明细不可编辑，但新增的明细可以编辑
            if(getDetailFormValues(form).dtl_id&&!excel.detailProps["isEdit"]){
                viewAttr = 1;
            }
        }

        let realOptions = _.isArray(filtedOptions) ? filtedOptions : options;
		if(fieldName.indexOf('_')>-1){
            let fieldnames = fieldName.split('_')[0];
            let fieldIndex = fieldName.split('_')[1];
            fieldnames = fieldnames+'options'
			try{
				let realOptionsCopy = DetailDatas[fieldIndex][fieldnames];
				if(realOptionsCopy){
					realOptions = realOptionsCopy;
				}
			}catch(e){
				realOptions =realOptions;
			}
            
        }
        realOptions = realOptions.filter(f => f.cancel != '1');
        // realOptions = realOptions.map(option => {
        //     return {
        //         ...option,
        //         selected: viewAttr == '1'? false: option.isdefault == 'y'
        //     }
        // })
        // const value1 = value ? value : WeaTools.getSelectDefaultValue(realOptions);
        const value1 = value
        let layoutProps = {};
        if (!isdetail) {
            layoutProps = {
                layout: document.getElementById("select" + fieldName),
                useSelfLayout: true
            }
        }
        //打印模式下radio框只显示选中值
        if(card.params.type == "4" && fieldtype == '3' ){
            let newfieldName = fieldName;
            if(newfieldName.indexOf('_')>-1){
                newfieldName = newfieldName.split('_')[0];
            }
            if(card.variableMap[`radioPrintText_${newfieldName}`] === true){
                fieldtype = 1;
            }
        }
        let canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && isdetail && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
		let isDisplay = '';
        if(!canQuickedit){
            isDisplay = 'none';
        }
        return (
            <div id={"select" + fieldName} className={`${canQuickedit ? 'cube-card-editformitem ':'cube-card-editformitem2'} fieldValue ${className}`} data-fieldattr={viewAttr} data-fieldmark={fieldName} 
            {...cell.cellProps}
            onClick={() => { canQuickedit && quickEditStore.lockEditFormItem(fieldName); }}
            >
                <WeaSelect ecId={`${this && this.props && this.props.ecId || ''}_WeaSelect@fsyo9r`}
                    className={isdetail ? 'cube-detail-select cube-card-select' : 'cube-card-select'}
                    options={[{ key: '', showname: '' }, ...realOptions]}
                    fieldName={fieldName}
                    viewAttr={viewAttr}
                    detailtype={fieldtype}
                    fieldshowtypes={fieldshowtypes}
                    value={value1}
                    onChange={bindObj.onChange}
                    {...layoutProps}
                    supportCancel
                />
                <span className="editicon" style={{display:isDisplay}}><i className="icon-coms-edit" ></i></span>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/select-element/index.tsx